import { render, staticRenderFns } from "./DTPEdit.vue?vue&type=template&id=7f0f680a&"
import script from "./DTPEdit.vue?vue&type=script&lang=js&"
export * from "./DTPEdit.vue?vue&type=script&lang=js&"
import style0 from "./DTPEdit.vue?vue&type=style&index=0&id=7f0f680a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports